module.exports = __webpack_public_path__ + "static/media/error-500.a1e6f477.svg";